import React, { useState } from 'react'
import styles from './index.module.scss'
import store from '@/store'
import classNames from 'classnames'
function Content() {
  const [isShowScene, setIsShowScene] = useState(false)
  const [isShowPoem, setIsShowPoem] = useState(false)
  const [isShowPano, setIsShowPano] = useState(false)
  const [isShowBack, setIsShowBack] = useState(true)
  const [currentLangue, setCurrentLangue] = useState('ZH')
  // 添加到全局，进入A7的时候触发
  window.currentLangue = setCurrentLangue
  window.setIsShowPano = setIsShowPano
  // 阅读碑中故事
  window.backToyblm = () => {
    const panoramicRoot = document.getElementById('panoramic-root') as HTMLElement
    setIsShowScene(false)
    setIsShowPano(false)
    setIsShowPoem(false)
    panoramicRoot.style.display = 'none'
    store.dispatch({ type: 'layout/unityDel', payload: false })
    store.dispatch({ type: 'layout/unityKey', payload: Date.now() })
    window.location.replace('../index.html#/wjwj?to=yblm')
  }
  // 大场景点击了程哲碑
  window.backczbClick = (state: boolean) => {
    if (state) {
      setIsShowBack(false)
    } else {
      setIsShowBack(true)
    }
  }

  window.openPoem = () => {
    setIsShowPoem(true)
  }

  const onClickBack = () => {
    if (isShowPoem) {
      setIsShowPoem(false)
    } else if (isShowScene) {
      setIsShowScene(false)
      setIsShowPano(true)
    } else {
      const panoramicRoot = document.getElementById('panoramic-root') as HTMLElement
      setIsShowScene(false)
      setIsShowPano(false)
      panoramicRoot.style.display = 'none'
      window.location.replace('#/wjwj')
      // 改变unity的key，告诉wjwj页面重新判断unity是否被销毁
      store.dispatch({ type: 'layout/unityDel', payload: false })
      store.dispatch({ type: 'layout/unityKey', payload: Date.now() })
    }
  }
  const onClickSkip = () => {
    setIsShowPoem(false)
    setIsShowScene(true)
  }

  return (
    <div className={classNames(styles.content, currentLangue === 'EN' ? styles.contentEn : '')} id='pageIframe'>
      <div id='A7Back' onClick={() => onClickBack()} style={{ display: isShowBack ? 'block' : 'none' }}>
        <img src={`./myData/img/btn_back${currentLangue === 'EN' ? 'En' : ''}.png`} alt='' />
      </div>

      {isShowPano && !isShowScene ? <iframe style={{ display: isShowPano && !isShowScene ? 'block' : 'none' }} title='panoramic' id='panoramic' src='Pano/index.html' /> : null}

      <div className='poem' id='A7Poem' style={{ display: isShowPoem ? 'flex' : 'none' }}>
        <div className='skip' onClick={() => onClickSkip()}>
          <div className='text'>{currentLangue === 'ZH' ? '跳过' : 'Skip'}</div>
          <img src={require('@/assets/img/btn_skip.png')} alt='' />
        </div>
        {currentLangue === 'EN' ? (
          <div className='content' style={{ overflow: 'auto', width: '83%', padding: '30px 0', height: '90%', justifyContent: 'start' }}>
            During the Guangxu period of the Qing Dynasty
            <br />
            After its discovery, the Cheng Zhe Stele was once kept in the Ancient Buddhist Hall in Dongcheng Village, Shangdang District, Changzhi City.
            <br /> From the Northern Dynasties to the Song and Jin Dynasties
            <br /> Buddhist activities have always flourished here.
            <br />
            The morning bell breaks through the morning mist, the evening drum sweeps across the fields.
            <br /> Amidst the swirling incense smoke, worshippers come and go in an endless stream.
            <br /> Buddhist chants and everyday life coexist harmoniously.
            <br /> The sound of metal and stone echoed endlessly.
            <br />
            Today, the ancient Buddhist hall is no longer filled with the sounds of Buddhist rituals. <br />
            Only the silent palaces remain standing in the passage of time.
            <br /> Standing under the eaves, one can feel the fleeting past of Cheng Zhe's monument and the bygone glory of the ancient Buddhist hall. <br />
            It leaves behind an unfinished sense of melancholy and lingering imagination.
          </div>
        ) : (
          <div className='content'>
            清光绪年间
            <br /> 程哲碑发现后曾存于长治市上党区东呈村古佛堂
            <br /> 自北朝肇始，至宋金时期
            <br /> 这里始终佛事兴盛 <br /> 晨钟撞破晨雾，暮鼓漫过田畴
            <br /> 缭绕香火中，信众往来不绝 <br /> 梵音与尘世烟火相融共生
            <br /> 金石回响不绝于耳 <br /> 如今古佛堂已不闻往日佛事喧声 <br />
            只余静默殿宇矗立时光里
            <br /> 驻足檐下 留下程哲碑的匆匆过往、古佛堂的繁华旧梦 <br />
            留下一段未尽的怅惘与悠长想象
          </div>
        )}
      </div>

      {isShowScene ? <iframe style={{ display: isShowScene ? 'block' : 'none' }} id='wjwjScene' title='wjwjScene' src='BigScene/index.html#/?m=SG-Oy6fyzoMQ0D' /> : null}
    </div>
  )
}

const MemoContent = React.memo(Content)

export default MemoContent
